import React from 'react';
import { motion } from 'framer-motion';
import { Download, Calendar, CheckSquare, RefreshCw } from 'lucide-react';
export function HowItWorksSection() {
  const steps = [{
    icon: Download,
    text: 'Descargas ebook + bonos (acceso inmediato).'
  }, {
    icon: Calendar,
    text: 'Sigues el Plan 7 días (15–20 min/día).'
  }, {
    icon: CheckSquare,
    text: 'Usas checklists para corregir lo que te sabotea.'
  }, {
    icon: RefreshCw,
    text: 'Repetís: en 2 semanas tu base se siente distinta.'
  }];
  return <section className="py-24 px-4 bg-bg-primary" data-id="element-103">
      <div className="container max-w-4xl mx-auto" data-id="element-104">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-105">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-text-primary mb-4" data-id="element-106">
            Cómo lo aplicas
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-4 gap-8" data-id="element-107">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="flex flex-col items-center text-center relative" data-id="element-108">
              {index < steps.length - 1 && <div className="hidden md:block absolute top-8 left-1/2 w-full h-0.5 bg-border-color -z-10" data-id="element-109" />}

              <div className="w-16 h-16 bg-bg-card border-2 border-cta-primary rounded-full flex items-center justify-center mb-6 shadow-[0_0_20px_rgba(34,197,94,0.2)] z-10" data-id="element-110">
                <step.icon className="w-8 h-8 text-cta-primary" data-id="element-111" />
              </div>

              <div className="bg-bg-card/50 p-4 rounded-xl border border-border-color w-full h-full flex items-center justify-center" data-id="element-112">
                <p className="text-text-normal font-medium" data-id="element-113">{step.text}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}